/* eslint-disable no-unused-expressions */
import { Chip, Grid, IconButton } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import DescriptionIcon from '@material-ui/icons/Description';
import { getInfoAttachment, setAffiliateAction } from '@webapps/business';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { getFileURLPDF } from '@webapps/utils';
import ModalFullScreen from 'components/ModalFullScreen/ModalFullScreen';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const Affiliate = ({ affiliation, close, refetchCandidature }) => {
  const {
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles();

  const { addToast } = useToast();

  const [open, setOpen] = useState(false);
  const [attachmentSelected, setAttachmentSelected] = useState();
  const [labelAttachment, setLabelAttachment] = useState();
  const [validAttachment, setValidAttachment] = useState();
  const [rejectAttachment, setRejectAttachment] = useState(false);
  const [disabledBtnClasse, setDisabledBtnClasse] = useState(false);
  const [path, setPath] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const {
    error: errorAffiliateAction,
    isLoading: isLoadingAffiliateAction,
    isSuccess: isSuccessAffiliateAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(setAffiliateAction);

  const {
    data: dataAttachment,
    // isLoading: isLoadingInfoAttachment,
    isSuccess: isSuccessInfoAttachment,
    mutateAsync: mutateInfoAttachment,
  } = useMutation(getInfoAttachment);

  const encloseAffiliate = async () => {
    await mutateSetAffiliateAction({
      idAffiliate: affiliation?.id,
      action: 'enclose',
    });
  };

  const getPathLink = (label, id, valid, statusAffiliate) => {
    setAttachmentSelected(id);
    setLabelAttachment(label);
    setValidAttachment(valid);
    statusAffiliate === 'HALF-REJECTED' &&
      valid === false &&
      setRejectAttachment(true);
    mutateInfoAttachment({
      id,
    });
    mutateInfoAttachment({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessInfoAttachment) {
      setPath('');
      getFileURLPDF(dataAttachment?.path, setPath);
      handleClickOpen();
    }
  }, [isSuccessInfoAttachment]);

  useEffect(() => {
    if (
      affiliation?.requiredFiles?.filter(({ valided }) => !valided).length === 0
    ) {
      setDisabledBtnClasse(false);
    } else {
      setDisabledBtnClasse(true);
    }
  }, [affiliation]);

  useEffect(() => {
    if (affiliation?.status === 'CREATED') {
      setDisabledBtnClasse(true);
    }
  }, [affiliation]);

  useEffect(() => {
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: "Des actions sont nécessaires pour finaliser l'affiliation",
      });
    }
    if (isSuccessAffiliateAction) {
      addToast({
        status: 'success',
        message: 'Affiliation aboutis avec succès',
      });
      close();
      refetchCandidature();
    }
  }, [isSuccessAffiliateAction, errorAffiliateAction]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container xs={10}>
        <Grid className={css({ marginTop: spacing(0) })} container>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Nom et prénom du candidat"
              value={`${affiliation?.student?.firstname} ${affiliation?.student?.lastname}`}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Adresse"
              value={affiliation?.student?.address?.label}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Intitulé du poste"
              value={affiliation?.job?.label}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Type de contrat"
              value={affiliation?.contractType?.label}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label="Equipe"
              value={affiliation?.team?.label}
            />
          </Grid>
        </Grid>
        <Grid
          className={css({
            display: 'flex',
            alignItems: 'center',
            marginTop: spacing(3),
          })}
          item
          xs={12}
        >
          <DescriptionIcon color="primary" />
          <div className={css({ marginLeft: spacing(1), color: 'black' })}>
            Document(s) reçu(s)
          </div>
        </Grid>
        <Grid className={css({ marginTop: spacing(1) })} item xs={12}>
          {affiliation?.requiredFiles.length > 0 ? (
            <TableContainer fullWidth>
              <Table>
                <TableBody>
                  {affiliation?.requiredFiles?.map(
                    ({ comments, id, label, uploaded, valided }, index) => (
                      <TableRow key={index}>
                        <TableCell align="left">{label}</TableCell>
                        <TableCell align="left">
                          {uploaded && valided && (
                            <Chip
                              classes={{
                                colorPrimary: css({
                                  background: '#dbfad8',
                                  color: 'green',
                                }),
                              }}
                              className={css({ margin: spacing(0.5) })}
                              color="primary"
                              label="Accepté(e)"
                              size="small"
                            />
                          )}
                          {!uploaded && (
                            <Chip
                              color="default"
                              label="Non renseigné"
                              size="small"
                            />
                          )}
                          {uploaded && !valided && !comments && (
                            <Chip
                              classes={{
                                colorPrimary: css({
                                  background: '#FAE8D7',
                                  color: '#FA8100',
                                }),
                              }}
                              className={css({ margin: spacing(0.5) })}
                              color="primary"
                              label="Attente"
                              size="small"
                            />
                          )}
                          {uploaded &&
                            !valided &&
                            comments &&
                            affiliation?.status === 'HALF-REJECTED' && (
                              <Chip
                                classes={{
                                  colorPrimary: css({
                                    background: '#fbd3d5',
                                    color: '#f90e1a',
                                  }),
                                }}
                                className={css({ margin: spacing(0.5) })}
                                color="primary"
                                label="Rejeté(e)"
                                size="small"
                              />
                            )}
                          {uploaded &&
                            !valided &&
                            comments &&
                            affiliation?.status === 'ACCEPTED' && (
                              <Chip
                                classes={{
                                  colorPrimary: css({
                                    background: '#FAE8D7',
                                    color: '#FA8100',
                                  }),
                                }}
                                className={css({ margin: spacing(0.5) })}
                                color="primary"
                                label="Attente"
                                size="small"
                              />
                            )}
                        </TableCell>
                        {uploaded && (
                          <TableCell align="left">
                            <IconButton size="small">
                              <Visibility
                                color="primary"
                                fontSize="small"
                                onClick={() =>
                                  getPathLink(
                                    label,
                                    id,
                                    valided,
                                    affiliation?.status
                                  )
                                }
                              />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            'Aucun document demandé'
          )}
          {affiliation?.additionalFiles.filter(({ uploaded }) => !uploaded)
            .length > 0 && (
              <div className={css({ marginTop: spacing(1) })}>
                <span className={css({ color: '#0060F9' })}>*</span> Merci de
                transmettre tous les documents à l'étudiant.
              </div>
            )}
          {affiliation?.requiredFiles?.length > 0 && (
            <div className={css({ marginTop: spacing(1) })}>
              <span className={css({ color: '#0060F9' })}>*</span> Tous les
              documents requis doivent être validés pour pouvoir terminer
              l'affiliation
            </div>
          )}
          {affiliation?.status === 'CREATED' && (
            <div className={css({ marginTop: spacing(1) })}>
              <span className={css({ color: '#0060F9' })}>*</span> L'affiliation
              doit être accepté par l'étudiant pour pouvoir la clôturer.
            </div>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({ textAlign: 'center', marginTop: spacing(2) })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 400 })}
            color="primary"
            disabled={disabledBtnClasse || isLoadingAffiliateAction}
            fullWidth
            onClick={encloseAffiliate}
            type="submit"
            variant="contained"
          >
            Ajouter dans l'équipe
          </Button>
        </Grid>
      </Grid>
      <ModalFullScreen
        idSelect={attachmentSelected}
        onCancel={handleClose}
        open={open}
        refetch={refetchCandidature}
        rejected={rejectAttachment}
        title={labelAttachment}
        valided={validAttachment}
      >
        <iframe
          className={css({ width: '100%', height: '100%' })}
          frameBorder="0"
          src={path}
          title="Fichier"
        />
      </ModalFullScreen>
    </div>
  );
};

Affiliate.propTypes = {
  affiliation: PropTypes.object,
  refetchCandidature: PropTypes.func,
  close: PropTypes.func,
};

export default Affiliate;
